import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromTemplateConfig from './template-config.reducer';

export const selectTemplateConfigState = createSelector(selectDashboardState, (dashboard) => dashboard?.templateConfig);

export const selectIsLoadingTemplateConfig = createSelector(
  selectTemplateConfigState,
  (templateConfigState) => templateConfigState?.loadingTemplateConfig
);

export const selectTemplateConfigLoaded = createSelector(
  selectTemplateConfigState,
  (templateConfigState) => templateConfigState?.templateConfigLoaded
);

export const selectTemplateConfig = createSelector(selectTemplateConfigState, fromTemplateConfig.selectAll);

export const selectSelectedTemplateConfig = createSelector(
  selectTemplateConfigState,
  (templateConfigState) => templateConfigState?.templateConfig
);
